import { ConstantsContext } from "@context/constantsContext";
import {
  returnCurrencyScale,
  returnMarketScale,
} from "@features/MarketOrder/components/MarketCard/SelectDigitalCurrency/Functions/scale";
import { useContext } from "react";

export function GetCurrencyScale(FirstCurrencyUnit) {
  const constants = useContext(ConstantsContext);

  return returnCurrencyScale(constants?.orderScaleMap, FirstCurrencyUnit);
}

export function GetMarketScale(SecondCurrencyUnit) {
  const constants = useContext(ConstantsContext);
  return returnMarketScale(
    constants?.marketOrderPriceScaleMap,
    SecondCurrencyUnit
  );
}
